/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_RedirectInputs */

const cs_billing_top_up_redirect = /** @type {(inputs: Billing_Top_Up_RedirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesměrování na platbu…`)
};

const en_billing_top_up_redirect = /** @type {(inputs: Billing_Top_Up_RedirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting to payment…`)
};

/**
* | output |
* | --- |
* | "Redirecting to payment…" |
*
* @param {Billing_Top_Up_RedirectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_redirect = /** @type {((inputs?: Billing_Top_Up_RedirectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_RedirectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_redirect(inputs)
	return cs_billing_top_up_redirect(inputs)
});